import React, { useEffect, useState } from "react";
import { Box, CircularProgress, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AppButton } from "../components/InputComponents";
import useStyles from "./SaveResult.style";
import Cookies from 'universal-cookie';


const cookies = new Cookies();
const SaveResult = props => {
	const classes = useStyles();

	const [checkChildrenQtySuccess, setCheckChildrenQtySuccess] = useState(false);
	const [saving, setSaving] = useState(true);
	const [success, setSuccess] = useState();
	const { t } = useTranslation();
	const { pregnancies, adoptions, childrenLoss, currentChildrenQty: currentChildrenQtyFromFPQ, stepchildren } = props;

	//Check if resulting children qty from profile matches the qty on goal
	useEffect(() => {
		const pregnanciesOutcomeQty = pregnancies
			.map(pregnancy => pregnancy.liveBirthQty - pregnancy.placedAdoptionQty)
			.reduce((acc, item) => acc + item, 0);
		const stepchildrenQty = parseInt(stepchildren.reduce((acc, stepchild) => acc + parseInt(stepchild.stepchildrenQty), 0));
		const adoptionsQty = parseInt(adoptions
			.reduce((acc, adoption) => acc + parseInt(adoption.childrenQty), 0));
		const lossesQty = childrenLoss
			.reduce((acc, loss) => acc + parseInt(loss.childrenQty), 0);

		const currentChildrenQtyFromProfile = pregnanciesOutcomeQty + adoptionsQty + stepchildrenQty - lossesQty;

		setCheckChildrenQtySuccess(currentChildrenQtyFromProfile === currentChildrenQtyFromFPQ);
	}, [adoptions, childrenLoss, currentChildrenQtyFromFPQ, pregnancies]);

	//Save profile on page load
	useEffect(() => {
		const saveProfile = async () => {
			try {
				let response = await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_PATIENT_PROFILE}`, {
					method: 'post',
					headers: {
						'X-ACCESS-TOKEN': cookies.get('token')
					},
					body: new URLSearchParams({
						dateOfBirth: props.dateOfBirth,
						races: props.races,
						raceSelfDescribe: props.raceSelfDescribe,
						gender: props.gender,
						genderIdentity: props.genderIdentity,
						genderIdentitySelfDescribe: props.genderIdentitySelfDescribe,
						sexualPreferences: props.sexualPreferences,
						sexualPreferenceSelfDescribe: props.sexualPreferenceSelfDescribe,
						relationshipStatus: props.relationshipStatus,
						childrenPlan: props.childrenPlan,
						plannedChildBearingYears: props.plannedChildBearingYears,
						thoughtAboutDesChildren: props.thoughtAboutDesChildren,
						childbearingYearFrame: props.childbearingYears,
						currentChildrenQty: props.currentChildrenQty,
						desiredChildrenQty: props.desiredChildrenQty,
						firstPeriodAge: props.firstPeriodAge,
						sexuallyActiveAge: props.sexuallyActiveAge,
						menopause: props.menopause,
						menopauseAge: props.menopauseAge,
						menopauseStatus: props.menopauseStatus,
						menopauseReason: props.menopauseReason,
						menopauseSymptonAge: props.menopauseSymptonAge,
						selectedMenopauseSymptons: props.selectedMenopauseSymptons,
						haveBeenPregnant: props.haveBeenPregnant,
						currentPregnancyDueDate: props.currentPregnancyDueDate,
						anyCancerDiagnosis: props.anyCancerDiagnosis,
						anyWaitingCancerDiagnosis: props.anyWaitingCancerDiagnosis,
						currentSiteOfCancer: props.currentSiteOfCancer,
						pendingCancerDiagnosis: props.pendingCancerDiagnosis,
						otherPendingCancerDiagnosis: props.otherPendingCancerDiagnosis,
						pregnancies: JSON.stringify(props.pregnancies),
						adoptions: JSON.stringify(props.adoptions),
						stepchildren: JSON.stringify(props.stepchildren),
						childrenLoss: JSON.stringify(props.childrenLoss),
						contraception: JSON.stringify(props.contraception),
						fertilityPreservation: JSON.stringify(props.fertilityPreservation),
						fertilityTreatment: JSON.stringify(props.fertilityTreatment),
						cancerDiagnosisAndTreatments: JSON.stringify(props.cancerDiagnosisAndTreatments),
						anyGeneticTesting: props.anyGeneticTesting,
						geneticTesting: JSON.stringify(props.geneticTesting)
					})
				});
				setSuccess(response.ok);
			} catch (error) {
				console.log(error);
				setSuccess(false);
			} finally {
				setSaving(false);
			}
		};

		if (!checkChildrenQtySuccess) return;
		saveProfile();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [checkChildrenQtySuccess]);

	const SavingResultComponent = props => {
		if (props.success === undefined) return null;
		if (!props.success) return (
			<Box className={classes.savingInfo}>
				{t('repliQuestionnaire.saving.failure')}
			</Box>
		);
		return (
			<Box className={classes.savingInfo}>
				{t('repliQuestionnaire.saving.success')}
			</Box>
		);
	}

	return (
		<Box className={classes.root}>
			<Box className={classes.title}>
				<Typography variant="h4">
					{t('repliQuestionnaire.saving.title')}
				</Typography>
			</Box>
			<Box className={classes.infoText}>
				{t('repliQuestionnaire.saving.info')}
			</Box>
			{
				checkChildrenQtySuccess &&
				<>
					{
						saving &&
						<Box className={classes.savingInfo}>
							{t('repliQuestionnaire.saving.pending')}&nbsp;&nbsp;&nbsp;&nbsp;
							<CircularProgress color="inherit" />
						</Box>
					}
					<SavingResultComponent success={success} />
					<Box className={classes.footer}>
						<AppButton
							component={Link}
							to="/app/myrepli"
							variant="contained"
							color="secondary"
							fullWidth
							size="large"
						>
							{t('repliQuestionnaire.saving.buttonLabel')}
						</AppButton>
					</Box>
				</>
			}
			{
				!checkChildrenQtySuccess &&
				<>
					<div style={{ marginTop: 20 }}>
						<Typography variant="h5" color="error">Current number of children entered does not match the one of your profiles pregnancies, adoptions, stepchild and loss.</Typography>
						<Typography variant="h6" color="error">Please review your profile.</Typography>
					</div>
					<Box className={classes.footer}>
						<AppButton
							variant="contained"
							color="secondary"
							fullWidth
							size="large"
							onClick={() => props.onReviewProfileClick(1)}
						>
							Review Profile
						</AppButton>
					</Box>
				</>
			}

		</Box>
	);
};

export default SaveResult;
